import type { ComponentChildren } from 'preact';
import { useEffect } from 'preact/hooks';

interface Props {
  open: boolean;
  onClose: () => void;
  title?: string;
  children?: ComponentChildren;
  actions?: ComponentChildren;
  maxWidth?: number;
}

export function Modal({ open, onClose, title, children, actions, maxWidth }: Props) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      class="modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div class="modal" style={maxWidth ? { maxWidth: `${maxWidth}px` } : undefined}>
        {title && <h2>{title}</h2>}
        {children}
        {actions && <div class="modal-actions">{actions}</div>}
      </div>
    </div>
  );
}
